<template>
  <div>
    <div v-if="isLoading" class="text-center py-4">Memuat data Rencana Aksi...</div>
    <div v-else-if="loadError" class="text-center text-danger py-4">{{ loadError }}</div>
    <b-form v-else :class="{ 'form-disabled': readOnly }">
      <div class="row">
        <div class="col-12">
          <legend class="text-black fw-bold">Identitas KKPRL</legend>
        </div>

        <div class="col-md-6 mb-3">
          <label for="no_kkprl">Nomor KKPRL <span class="text-danger">*</span></label>
          <div class="d-flex">
            <b-form-input
              id="no_kkprl"
              v-model="form.no_kkprl"
              :disabled="readOnly"
              v-validate="'required'"
              name="Nomor KKPRL"
            />
          </div>
          <span v-if="errors.has('Nomor KKPRL')" class="text-danger">{{ errors.first('Nomor KKPRL') }}</span>
        </div>

        <div class="col-md-6 mb-3">
          <label for="jenis_kegiatan">Jenis Kegiatan <span class="text-danger">*</span></label>
          <v-select
            input-id="jenis_kegiatan"
            v-model="form.jenis_kegiatan"
            :disabled="readOnly"
            :options="['Berusaha', 'Non Berusaha']"
            v-validate="'required'"
            name="Jenis Kegiatan"
          />
          <span v-if="errors.has('Jenis Kegiatan')" class="text-danger">
            {{ errors.first('Jenis Kegiatan') }}
          </span>
        </div>

        <div class="col-md-6 mb-3">
          <label for="nama_pemegang">Nama Pemegang <span class="text-danger">*</span></label>
          <b-form-input
            id="nama_pemegang"
            v-model="form.nama_pemegang"
            :disabled="readOnly"
            v-validate="'required'"
            name="Nama Pemegang"
          />
          <span v-if="errors.has('Nama Pemegang')" class="text-danger">{{ errors.first('Nama Pemegang') }}</span>
        </div>

        <div class="col-md-6 mb-3">
          <label for="npwp">NPWP <span class="text-danger">*</span></label>
          <b-form-input
            id="npwp"
            v-model="form.npwp"
            :disabled="readOnly"
            v-validate="'required'"
            name="NPWP"
            v-mask="'##.###.###.#-###.####'"
          />
          <span v-if="errors.has('NPWP')" class="text-danger">{{ errors.first('NPWP') }}</span>
        </div>

        <div v-if="form.jenis_kegiatan === 'Berusaha'" class="col-md-6 mb-3">
          <label for="nib">NIB <span class="text-danger">*</span></label>
          <b-form-input id="nib" v-model="form.nib" :disabled="readOnly" v-validate="'required'" name="NIB" />
          <span v-if="errors.has('NIB')" class="text-danger">{{ errors.first('NIB') }}</span>
        </div>

        <div class="col-md-6 mb-3">
          <label>Provinsi <span class="text-danger">*</span></label>
          <v-select
            v-model="form.provinsi"
            :disabled="readOnly"
            :options="provinsiOptions"
            :reduce="(data) => data.nama_provinsi"
            label="nama_provinsi"
            multiple
            v-validate="'required'"
            name="Provinsi"
          />
          <span v-if="errors.has('Provinsi')" class="text-danger">{{ errors.first('Provinsi') }}</span>
        </div>

        <div class="col-md-6 mb-3">
          <label for="tanggal_terbit">Tanggal Terbit <span class="text-danger">*</span></label>
          <b-form-input
            id="tanggal_terbit"
            v-model="form.tanggal_terbit"
            :disabled="readOnly"
            type="date"
            v-validate="'required'"
            name="Tanggal Terbit"
          />
          <span v-if="errors.has('Tanggal Terbit')" class="text-danger">{{ errors.first('Tanggal Terbit') }}</span>
        </div>

        <div class="col-12 mt-4">
          <legend class="text-black fw-bold">Rencana Aksi</legend>
        </div>

        <div class="col-md-6 mb-3">
          <label>Jenis Rencana Aksi <span class="text-danger">*</span></label>
          <v-select
            v-model="form.jenis_rencana_aksi"
            :disabled="readOnly"
            :options="['Pertama', 'Lanjutan']"
            v-validate="'required'"
            name="Jenis Rencana Aksi"
          />
          <span v-if="errors.has('Jenis Rencana Aksi')" class="text-danger">
            {{ errors.first('Jenis Rencana Aksi') }}
          </span>
        </div>

        <div class="col-md-6 mb-3">
          <label>Metode Penilaian Pelaksanaan <span class="text-danger">*</span></label>
          <v-select
            v-model="form.metode_penilaian_pelaksanaan"
            :disabled="readOnly"
            :options="['Lapangan', 'Terpusat']"
            v-validate="'required'"
            name="Metode Penilaian Pelaksanaan"
          />
          <span v-if="errors.has('Metode Penilaian Pelaksanaan')" class="text-danger">
            {{ errors.first('Metode Penilaian Pelaksanaan') }}
          </span>
        </div>

        <div class="col-md-6 mb-3">
          <label>Prioritas <span class="text-danger">*</span></label>
          <v-select
            v-model="form.prioritas"
            :disabled="readOnly"
            :options="prioritasOptions"
            :reduce="(data) => data.value"
            label="text"
            v-validate="'pilih_prioritas'"
            name="Prioritas"
          />
          <span v-if="errors.has('Prioritas')" class="text-danger">{{ errors.first('Prioritas') }}</span>
        </div>

        <div class="col-md-6 mb-3">
          <label for="tanggal_penilaian">Tanggal Penilaian <span class="text-danger">*</span></label>
          <b-form-input
            id="tanggal_penilaian"
            v-model="form.tanggal_penilaian"
            :disabled="readOnly"
            type="date"
            v-validate="'required'"
            name="Tanggal Penilaian"
          />
          <span v-if="errors.has('Tanggal Penilaian')" class="text-danger">
            {{ errors.first('Tanggal Penilaian') }}
          </span>
        </div>

        <div class="col-md-6 mb-3">
          <label for="lokasi_penilaian">Lokasi Penilaian <span class="text-danger">*</span></label>
          <b-form-input
            id="lokasi_penilaian"
            v-model="form.lokasi_penilaian"
            :disabled="readOnly"
            v-validate="'required'"
            name="Lokasi Penilaian"
          />
          <span v-if="errors.has('Lokasi Penilaian')" class="text-danger">
            {{ errors.first('Lokasi Penilaian') }}
          </span>
        </div>

        <div class="col-md-6 mb-3">
          <label>Tim Penilai <span class="text-danger">*</span></label>
          <v-select
            v-model="form.id_tim_penilai"
            :disabled="readOnly"
            :options="timPenilaiOptions"
            :reduce="(data) => data.id"
            label="nama"
            multiple
            v-validate="'required'"
            name="Tim Penilai"
          />
          <span v-if="errors.has('Tim Penilai')" class="text-danger">{{ errors.first('Tim Penilai') }}</span>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import vSelect from 'vue-select'
import api from '@/services/api'
import { buildRencanaAksiFormData } from '../rencanaAksiFormData'

export default {
  components: { vSelect },
  props: {
    readOnly: { type: Boolean, default: true },
    rencanaAksiId: { type: [String, Number], default: null },
  },
  data() {
    return {
      isLoading: false,
      isSubmitting: false,
      loadError: '',
      form: {
        no_kkprl: '',
        jenis_kegiatan: null,
        npwp: '',
        nama_pemegang: '',
        nib: '',
        provinsi: [],
        tanggal_terbit: '',
        jenis_rencana_aksi: null,
        metode_penilaian_pelaksanaan: null,
        prioritas: null,
        tanggal_penilaian: '',
        lokasi_penilaian: '',
        id_tim_penilai: [],
      },
      prioritasOptions: [
        { text: 'Ya', value: true },
        { text: 'Tidak', value: false },
      ],
      timPenilaiOptions: [],
      provinsiOptions: [],
    }
  },
  async mounted() {
    await Promise.all([this.getTimPenilai(), this.getProvinsi()])
    if (this.rencanaAksiId) await this.loadRencanaAksi()
  },
  watch: {
    'form.jenis_kegiatan'(jenisKegiatan) {
      if (this.readOnly) return
      if (jenisKegiatan !== 'Berusaha') {
        this.form.nib = ''
        this.errors.remove('NIB')
      }
    },
  },
  methods: {
    async validateForm() {
      return (await this.$validator.validateAll()) && !this.errors.any()
    },
    async saveRencanaAksi() {
      if (this.isSubmitting) return false
      if (!(await this.validateForm())) return false

      const result = await Swal.fire({
        icon: 'question',
        title: 'Simpan Perubahan?',
        text: 'Apakah Anda yakin ingin menyimpan perubahan Rencana Aksi ini?',
        showCancelButton: true,
        confirmButtonText: 'Ya, Simpan',
        cancelButtonText: 'Batal',
      })
      if (!result.isConfirmed) return false

      this.isSubmitting = true
      this.$emit('submitting', true)
      try {
        await api.post(`api/rencana_aksi/${this.rencanaAksiId}`, buildRencanaAksiFormData(this.getFormData()))
        await Swal.fire({
          icon: 'success',
          title: 'Berhasil',
          text: 'Perubahan Rencana Aksi berhasil disimpan.',
        })
        await this.loadRencanaAksi()
        return true
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Gagal',
          text: error.response?.data?.message || 'Terjadi kesalahan saat menyimpan perubahan Rencana Aksi.',
        })
        return false
      } finally {
        this.isSubmitting = false
        this.$emit('submitting', false)
      }
    },
    getFormData() {
      return {
        ...this.form,
        provinsi: [...(this.form.provinsi || [])],
        id_tim_penilai: [...(this.form.id_tim_penilai || [])],
      }
    },
    async setFormData(data) {
      this.form = {
        ...data,
        provinsi: [...(data.provinsi || [])],
        id_tim_penilai: [...(data.id_tim_penilai || [])],
      }
      await this.$nextTick()
      this.$validator.reset()
    },
    async loadRencanaAksi() {
      this.isLoading = true
      this.loadError = ''
      try {
        const response = await api.get(`api/rencana_aksi/${this.rencanaAksiId}`)
        const data = response.data?.data
        if (!data) {
          this.loadError = 'Data Rencana Aksi tidak ditemukan.'
          return
        }
        await this.setFormData(this.mapRencanaAksiToForm(data))
        this.$emit('loaded', data)
      } catch (error) {
        this.loadError = error.response?.data?.message || 'Gagal memuat data Rencana Aksi.'
        Swal.fire('Gagal', this.loadError, 'error')
      } finally {
        this.isLoading = false
      }
    },
    mapRencanaAksiToForm(data) {
      const provinsi = Array.isArray(data.provinsi) ? data.provinsi : data.provinsi ? [data.provinsi] : []
      const timPenilai = Array.isArray(data.tim_penilai) ? data.tim_penilai : []

      provinsi.forEach((nama) => {
        if (!this.provinsiOptions.some((option) => option.nama_provinsi === nama)) {
          this.provinsiOptions.push({ nama_provinsi: nama })
        }
      })
      timPenilai.forEach((item) => {
        if (!this.timPenilaiOptions.some((option) => option.id === item.id)) {
          this.timPenilaiOptions.push(item)
        }
      })

      return {
        no_kkprl: data.no_kkprl || '',
        jenis_kegiatan: data.jenis_kegiatan || null,
        npwp: data.npwp || '',
        nama_pemegang: data.nama_pemegang || '',
        nib: data.nib || '',
        provinsi,
        tanggal_terbit: data.tanggal_terbit || '',
        jenis_rencana_aksi: data.jenis_rencana_aksi || null,
        metode_penilaian_pelaksanaan: data.metode_penilaian_pelaksanaan || null,
        prioritas: typeof data.prioritas === 'boolean' ? data.prioritas : null,
        tanggal_penilaian: data.tanggal_penilaian || '',
        lokasi_penilaian: data.lokasi_penilaian || '',
        id_tim_penilai: Array.isArray(data.id_tim_penilai)
          ? [...data.id_tim_penilai]
          : timPenilai.map((item) => item.id),
      }
    },
    async getTimPenilai() {
      const res = await api.get('api/user?filter=roles,contains,Penilai;nama_upt,=,PUSAT&limit=0')
      this.timPenilaiOptions = res.data.data
    },
    async getProvinsi() {
      const res = await api.get('api/provinsi?sort=id,ASC&limit=0')
      this.provinsiOptions = res.data.data
    },
  },
}
</script>

<style scoped>
.form-disabled :deep(input:disabled),
.form-disabled :deep(.vs__dropdown-toggle),
.form-disabled :deep(.vs--disabled .vs__dropdown-toggle) {
  background-color: #e9ecef !important;
  border-color: #ced4da !important;
  color: #6c757d !important;
  cursor: not-allowed !important;
  opacity: 1;
}

.form-disabled :deep(.vs--disabled .vs__selected),
.form-disabled :deep(.vs--disabled .vs__search) {
  color: #6c757d !important;
  cursor: not-allowed !important;
}
</style>
